import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) e.target.classList.add('visible')
      })
    }, { threshold: 0.15 })

    this.element.querySelectorAll('.reveal').forEach(el => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
